export default "__VITE_ASSET__CNhm9a5r__"